import { IndicationEnum } from '../enums';

/**
 * @deprecated use mapFromSuccessIndication()
 */
export function mapFromIndication(indication: IndicationEnum): boolean {
    return indication === IndicationEnum.Yes;
}
